var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/emoji/emoji.tsx";
const _excluded = ["emoji", "alt"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { removeVS16s, toCodePoints } from 'soapbox/utils/emoji';
import { joinPublicPath } from 'soapbox/utils/static';

/** A single emoji image. */
const Emoji = props => {
  const {
    emoji,
    alt
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const codepoints = toCodePoints(removeVS16s(emoji));
  const filename = codepoints.join('-');
  if (!filename) return null;
  return /*#__PURE__*/React.createElement("img", _extends({
    draggable: "false",
    alt: alt || emoji,
    src: joinPublicPath("packs/emoji/".concat(filename, ".svg"))
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 5
    }
  }));
};

export default Emoji;